var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Provider'),_c('div',{staticClass:"d-flex content-wrapper justify-content-between min-h-70 gap-3 mt-3 px-3"},[_c('Content'),_c('SideMenu')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }